import React from 'react';
import {func, string, bool} from 'prop-types';
import {Link} from 'react-router-dom';
import {FormattedMessage} from "react-intl";
import {Button} from 'semantic-ui-react';
import HardCodedContent from "./HardCodedContent";

class HardcodedButton extends React.Component {
  static propTypes = {
    getUrl: func.isRequired,
    relativeUrl: bool.isRequired,
    className: string,
    text: string,
    textKey: string
  };

  render() {
    const url = this.props.getUrl(this.props.formProxy);

    const button = (
      <Button primary className={"hardcoded-btn" + (this.props.className ? " " + this.props.className : "")}>
        {this.props.text ? this.props.text : ""}
        {this.props.textKey ? <FormattedMessage id={this.props.textKey}/> : ""}
      </Button>
    );

    return (
      <HardCodedContent>
        {this.props.relativeUrl ? <Link to={url}>{button}</Link> : <a href={url} target='_blank'>{button}</a>}
      </HardCodedContent>
    );
  }
}

export default HardcodedButton;



// WEBPACK FOOTER //
// ./public/components/forms/HardcodedButton.jsx